// extracted by mini-css-extract-plugin
export var button = "_mk-0";
export var donut = "_mk-1";
export var donutFill = "_mk-3";
export var donutTrack = "_mk-2";